<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="application_createNewInstance"
        class="form-control-label">{{$t('views.application.form.createNewInstance')}}</label>
      <b-row>
        <b-col>
          <b-form-group>
            <b-form-radio-group
              id="application_createNewInstance"
              name="application_createNewInstance"
              buttons
              button-variant="outline-primary"
              v-model="item.createNewInstance"
            >
              <b-form-radio :value="false">{{$t("buttons.no")}}</b-form-radio>
              <b-form-radio class="btn-success" :value="true">{{$t("buttons.yes")}}</b-form-radio>
              <b-form-invalid-feedback v-if="isInvalid('createNewInstance')" :state="false">{{ violations.confirmationCreatingSubdomain }}</b-form-invalid-feedback>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <div class="form-group">
      <label
        for="application_applicationType"
        class="form-control-label">{{$t('views.application.form.idUserData')}}</label>
      <base-select-input
        required
        v-model="item.idUserData"
        :search-callback="userDataSearchCallback"
        :query-param="'userdata'"
        :display-values="['fullName', 'firmname1']"
        :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
      ></base-select-input>
    </div>
    <div class="form-group">
      <label
        for="application_applicationType"
        class="form-control-label">{{$t('views.application.form.applicationType')}}</label>
      <el-select
        id="application_applicationType"
        :class="['select-default', isInvalid('applicationType') ? 'select-danger' : '']"
        placeholder=""
        filterable
        v-model="item.applicationType">
        <el-option v-for="option in applicationTypes"
                   class="select-default"
                   :value="option['@id']"
                   :label="option['title']"
                   :key="option['@id']">
        </el-option>
      </el-select>
    </div>
    <div class="form-group">
      <label
        for="application_server"
        class="form-control-label">{{$t('views.application.form.server')}}</label>
      <el-select
        id="application_server"
        :class="['select-default', isInvalid('server') ? 'select-danger' : '']"
        placeholder=""
        filterable
        v-model="item.server">
        <el-option v-for="option in servers"
                   class="select-default"
                   :value="option['@id']"
                   :label="option['title']"
                   :key="option['@id']">
        </el-option>
      </el-select>
    </div>
    <div class="form-group">
      <label
        for="application_domain"
        class="form-control-label">{{$t('views.application.form.domain')}}</label>
      <el-select
        id="application_domain"
        :class="['select-default', isInvalid('domain') ? 'select-danger' : '']"
        placeholder=""
        filterable
        v-model="item.domain">
        <el-option v-for="option in domains"
                   class="select-default"
                   :value="option['@id']"
                   :label="option['domain']"
                   :key="option['@id']">
        </el-option>
      </el-select>
    </div>
    <div class="form-group">
      <label
        for="application_subdomain"
        class="form-control-label">{{$t('views.application.form.subdomain')}}</label>
      <input
        id="application_subdomain"
        v-model="item.subdomain"
        :class="['form-control', isInvalid('subdomain') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('subdomain', $event.target.value)">
      <div
        v-if="isInvalid('subdomain')"
        class="invalid-feedback">{{ violations.subdomain }}</div>
    </div>
    <div class="form-group">
      <label
        for="application_confirmationCreatingSubdomain"
        class="form-control-label">{{$t('views.application.form.confirmationCreatingSubdomain')}}</label>
      <b-row>
        <b-col>
        <b-form-group>
          <b-form-radio-group
            id="application_confirmationCreatingSubdomain"
            name="application_confirmationCreatingSubdomain"
            buttons
            button-variant="outline-primary"
            v-model="item.confirmationCreatingSubdomain"
            >
            <b-form-radio :value="false">{{$t("buttons.no")}}</b-form-radio>
            <b-form-radio class="btn-success" :value="true">{{$t("buttons.yes")}}</b-form-radio>
            <b-form-invalid-feedback v-if="isInvalid('confirmationCreatingSubdomain')" :state="false">{{ violations.confirmationCreatingSubdomain }}</b-form-invalid-feedback>
          </b-form-radio-group>
        </b-form-group>
        </b-col>
      </b-row>
    </div>
    <div class="form-group">
      <label
        for="application_connectionKey"
        class="form-control-label">{{$t('views.application.form.connectionKey')}}</label>
      <input
        id="application_connectionKey"
        v-model="item.connectionKey"
        :class="['form-control', isInvalid('connectionKey') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('connectionKey', $event.target.value)">
      <b-button @click="generateConnectionKey(20)">{{$t('buttons.generateKey')}}</b-button>
      <div
        v-if="isInvalid('connectionKey')"
        class="invalid-feedback">{{ violations.connectionKey }}</div>
    </div>
    <div class="form-group">
      <h6>{{$t('views.application.form.pusherInfo')}}</h6>
    </div>
    <div class="form-group">
      <label
        for="application_pusherAppId"
        class="form-control-label">{{$t('views.application.form.pusherAppId')}}</label>
      <input
        id="application_pusherAppId"
        v-model="item.pusherAppId"
        :class="['form-control', isInvalid('pusherAppId') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('pusherAppId', $event.target.value)">
      <div
        v-if="isInvalid('pusherAppId')"
        class="invalid-feedback">{{ violations.pusherAppId }}</div>
    </div>
    <div class="form-group">
      <label
        for="application_pusherAppKey"
        class="form-control-label">{{$t('views.application.form.pusherAppKey')}}</label>
      <input
        id="application_pusherAppKey"
        v-model="item.pusherAppKey"
        :class="['form-control', isInvalid('pusherAppKey') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('pusherAppKey', $event.target.value)">
      <div
        v-if="isInvalid('pusherAppKey')"
        class="invalid-feedback">{{ violations.pusherAppKey }}</div>
    </div>
    <div class="form-group">
      <label
        for="application_pusherAppSecret"
        class="form-control-label">{{$t('views.application.form.pusherAppSecret')}}</label>
      <input
        id="application_pusherAppSecret"
        v-model="item.pusherAppSecret"
        :class="['form-control', isInvalid('pusherAppSecret') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('pusherAppSecret', $event.target.value)">
      <div
        v-if="isInvalid('pusherAppSecret')"
        class="invalid-feedback">{{ violations.pusherAppSecret }}</div>
    </div>
    <div class="form-group">
      <label
        for="application_pusherCluster"
        class="form-control-label">{{$t('views.application.form.pusherCluster')}}</label>
      <input
        id="application_pusherCluster"
        v-model="item.pusherCluster"
        :class="['form-control', isInvalid('pusherCluster') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('pusherCluster', $event.target.value)">
      <div
        v-if="isInvalid('pusherCluster')"
        class="invalid-feedback">{{ violations.pusherCluster }}</div>
    </div>
    <div class="form-group">
      <h6>{{$t('views.application.form.swiftmailerInfo')}}</h6>
    </div>
    <div class="form-group">
      <label
        for="application_SwiftmailerTransport"
        class="form-control-label">{{$t('views.application.form.SwiftmailerTransport')}}</label>
      <input
        id="application_SwiftmailerTransport"
        v-model="item.SwiftmailerTransport"
        :class="['form-control', isInvalid('SwiftmailerTransport') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('SwiftmailerTransport', $event.target.value)">
      <div
        v-if="isInvalid('SwiftmailerTransport')"
        class="invalid-feedback">{{ violations.SwiftmailerTransport }}</div>
    </div>
    <div class="form-group">
      <label
        for="application_SwiftmailerHost"
        class="form-control-label">{{$t('views.application.form.SwiftmailerHost')}}</label>
      <input
        id="application_SwiftmailerHost"
        v-model="item.SwiftmailerHost"
        :class="['form-control', isInvalid('SwiftmailerHost') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('SwiftmailerHost', $event.target.value)">
      <div
        v-if="isInvalid('SwiftmailerHost')"
        class="invalid-feedback">{{ violations.SwiftmailerHost }}</div>
    </div>
    <div class="form-group">
      <label
        for="application_SwiftmailerUsername"
        class="form-control-label">{{$t('views.application.form.SwiftmailerUsername')}}</label>
      <input
        id="application_SwiftmailerUsername"
        v-model="item.SwiftmailerUsername"
        :class="['form-control', isInvalid('SwiftmailerUsername') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('SwiftmailerUsername', $event.target.value)">
      <div
        v-if="isInvalid('SwiftmailerUsername')"
        class="invalid-feedback">{{ violations.SwiftmailerUsername }}</div>
    </div>
    <div class="form-group">
      <label
        for="application_SwiftmailerPassword"
        class="form-control-label">{{$t('views.application.form.SwiftmailerPassword')}}</label>
      <input
        id="application_SwiftmailerPassword"
        v-model="item.SwiftmailerPassword"
        :class="['form-control', isInvalid('SwiftmailerPassword') ? 'is-invalid' : '']"
        type="password"
        placeholder=""
        @input="handleUpdateField('SwiftmailerPassword', $event.target.value)">
      <div
        v-if="isInvalid('SwiftmailerPassword')"
        class="invalid-feedback">{{ violations.SwiftmailerPassword }}</div>
    </div>
    <div class="form-group">
      <label
        for="application_SwiftmailerSenderType"
        class="form-control-label">{{$t('views.application.form.SwiftmailerSenderType')}}</label>
      <input
        id="application_SwiftmailerSenderType"
        v-model="item.SwiftmailerSenderType"
        :class="['form-control', isInvalid('SwiftmailerSenderType') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('SwiftmailerSenderType', $event.target.value)">
      <div
        v-if="isInvalid('SwiftmailerSenderType')"
        class="invalid-feedback">{{ violations.SwiftmailerSenderType }}</div>
    </div>
    <div class="form-group">
      <label
        for="application_SwiftmailerPort"
        class="form-control-label">{{$t('views.application.form.SwiftmailerPort')}}</label>
      <input
        id="application_SwiftmailerPort"
        v-model="item.SwiftmailerPort"
        :class="['form-control', isInvalid('SwiftmailerPort') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('SwiftmailerPort', $event.target.value)">
      <div
        v-if="isInvalid('SwiftmailerPort')"
        class="invalid-feedback">{{ violations.SwiftmailerPort }}</div>
    </div>
    <div class="form-group">
      <label
        for="application_SwiftmailerEncryption"
        class="form-control-label">{{$t('views.application.form.SwiftmailerEncryption')}}</label>
      <input
        id="application_SwiftmailerEncryption"
        v-model="item.SwiftmailerEncryption"
        :class="['form-control', isInvalid('SwiftmailerEncryption') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('SwiftmailerEncryption', $event.target.value)">
      <div
        v-if="isInvalid('SwiftmailerEncryption')"
        class="invalid-feedback">{{ violations.SwiftmailerEncryption }}</div>
    </div>
    <div class="form-group">
      <h6>{{$t('views.application.form.databaseInfo')}}</h6>
    </div>
<!--    <div class="form-group">-->
<!--      <label-->
<!--        for="application_databaseConnection"-->
<!--        class="form-control-label">{{$t('views.application.form.databaseConnection')}}</label>-->
<!--      <el-select-->
<!--        id="application_databaseConnection"-->
<!--        :class="['select-default', isInvalid('databaseConnection') ? 'select-danger' : '']"-->
<!--        placeholder=""-->
<!--        filterable-->
<!--        v-model="item.databaseConnection">-->
<!--        <el-option v-for="option in databaseConnections"-->
<!--                   class="select-default"-->
<!--                   :value="option['@id']"-->
<!--                   :label="option['title']"-->
<!--                   :key="option['@id']">-->
<!--        </el-option>-->
<!--      </el-select>-->
<!--    </div>-->
    <div class="form-group">
      <label>{{$t('views.application.form.databaseInfo')}}</label>
    </div>
    <div class="form-group">
      <label
        for="application_databaseConnection"
        class="form-control-label">{{$t('views.application.form.databaseConnection')}}</label>
      <el-select
        id="application_databaseConnection"
        :class="['select-default', isInvalid('databaseConnection') ? 'select-danger' : '']"
        placeholder=""
        filterable
        v-model="item.databaseConnection">
        <el-option v-for="option in databaseConnections"
                   class="select-default"
                   :value="option['@id']"
                   :label="option['title']"
                   :key="option['@id']">
        </el-option>
      </el-select>
    </div>
    <div class="form-group">
      <label
        for="application_databaseImportFile"
        class="form-control-label">{{$t('views.application.form.databaseImportFile')}}</label>
      <el-select
        id="application_databaseImportFile"
        :class="['select-default', isInvalid('databaseImportFile') ? 'select-danger' : '']"
        placeholder=""
        filterable
        v-model="item.databaseImportFile">
        <el-option v-for="option in databaseImportFiles"
                   class="select-default"
                   :value="option['@id']"
                   :label="option['title']"
                   :key="option['@id']">
        </el-option>
      </el-select>
    </div>
    <div class="form-group">
      <label
        for="application_databasePassword"
        class="form-control-label">{{$t('views.application.form.databasePassword')}}</label>
      <input
        id="application_databasePassword"
        v-model="item.databasePassword"
        :class="['form-control', isInvalid('databasePassword') ? 'is-invalid' : '']"
        type="password"
        placeholder=""
        @input="handleUpdateField('databasePassword', $event.target.value)">
      <div
        v-if="isInvalid('databasePassword')"
        class="invalid-feedback">{{ violations.databasePassword }}</div>
    </div>
    <div class="form-group">
      <h6>{{$t('views.application.form.sshConnectionInfo')}}</h6>
    </div>
    <div class="form-group">
      <label
        for="application_SSHUsername"
        class="form-control-label">{{$t('views.application.form.SSHUsername')}}</label>
      <input
        id="application_SSHUsername"
        v-model="item.SSHUsername"
        :class="['form-control', isInvalid('SSHUsername') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('SSHUsername', $event.target.value)">
      <div
        v-if="isInvalid('SSHUsername')"
        class="invalid-feedback">{{ violations.SSHUsername }}</div>
    </div>
    <div class="form-group">
      <label
        for="application_SSHPassword"
        class="form-control-label">{{$t('views.application.form.SSHPassword')}}</label>
      <input
        id="application_SSHPassword"
        v-model="item.SSHPassword"
        :class="['form-control', isInvalid('SSHPassword') ? 'is-invalid' : '']"
        type="password"
        required="true"
        placeholder=""
        @input="handleUpdateField('SSHPassword', $event.target.value)">
      <div
        v-if="isInvalid('SSHPassword')"
        class="invalid-feedback">{{ violations.SSHPassword }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-primary">{{$t('buttons.submit')}}</button>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ApiService from '@/utils/ApiService'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput.vue'

export default {
  components: {
    BaseSelectInput
  },
  data () {
    return {
      applicationTypes: [],
      databaseConnections: [],
      databaseImportFiles: [],
      domains: [],
      servers: []
    }
  },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    },

    generateConnectionKey: {
      type: Function,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      userDataItems: 'lists/list/userDataItems'
    }),
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  watch: {
    'item.server': function (val) {
      let params = {
        server: val
      }
      this.item.databaseConnection = null
      this.getDatabaseConnections(params)
    },
    'item.applicationType': function (val) {
      let params = {
        applicationType: val
      }
      // refresh database import files
      this.item.databaseImportFile = null
      this.getDatabaseImportFiles(params)
    }
  },

  created () {
    this.getApplicationTypes()
    this.getDatabaseConnections()
    this.getDomains()
    this.getServers()
    this.getDatabaseImportFiles()
  },
  destroyed () {
    // TODO: Do przemyślania
    this.resetLists()
  },

  methods: {
    ...mapActions({
      resetLists: 'lists/list/reset'
    }),
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false, isCompany: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    getApplicationTypes () {
      this.$http.get('api/application_types')
        .then(response => {
          this.applicationTypes = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    getDatabaseConnections (params = {}) {
      this.$http.get('api/database_connections', {
        params
      })
        .then(response => {
          this.databaseConnections = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    getDomains () {
      this.$http.get('api/domains')
        .then(response => {
          this.domains = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    getServers () {
      this.$http.get('api/servers')
        .then(response => {
          this.servers = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    getDatabaseImportFiles (params = {}) {
      this.$http.get('api/database_import_files', {
        params
      })
        .then(response => {
          this.databaseImportFiles = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
